import { render, staticRenderFns } from "./especeEffectif.vue?vue&type=template&id=47b0fb9e"
import script from "./especeEffectif.vue?vue&type=script&lang=js"
export * from "./especeEffectif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports